/** Micro-linhas rotativas na barra IA (ex-IaEngineLoading). */
export const IA_PENDING_MICRO_LINES = [
  'Lendo seu perfil…',
  'Cruzando séries de hoje…',
  'Ajustando o plano…',
  'Quase lá…',
];
